import { useState, useEffect } from "react";
import { GetUser } from "../../Services";
import { toast } from "react-toastify";

const AddEditDriver = ({
  editingDriver,
  setEditingDriver,
  setDrivers,
  setShowModal,
  vehicles = [], // passed from parent
}) => {
  const isEditing = Boolean(editingDriver);

  const [formData, setFormData] = useState({
    name: "",
    country: "",
    phone_number: "",
    email: "",
    registration_number: "",
    driving_license: "",
    notificationToken: "",
    accountStatus: "PENDING",
    status: "OFFLINE",
    wallet_balance: 0,
    vehicleId: "",
  });

  const [documents, setDocuments] = useState([]);
  const [drivingLicense, setDrivingLicence] = useState();
  const [nationalId, setNationalId] = useState();

  useEffect(() => {
    if (editingDriver) {
      setFormData({
        ...editingDriver,
        vehicleId: editingDriver.vehicles?.[0]?.id || "",
      });
    }
  }, [editingDriver]);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleFileChange = (e) => {
    setDocuments(e.target.files);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const formDataCreate = new FormData();

      // Append driver fields
      Object.keys(formData).forEach((key) => {
        if (formData[key] !== undefined && formData[key] !== "") {
          formDataCreate.append(key, formData[key]);
        }
      });

      // Append multiple documents
      Array.from(documents).forEach((doc) => {
        formDataCreate.append("documents", doc);
      });
      if (drivingLicense) {
        formDataCreate.append("drivingLicense", drivingLicense);
      }
      if (nationalId) {
        formDataCreate.append("nationalId", nationalId);
      }

      let response;
      if (isEditing) {
        response = await GetUser.DriverUpdate(formDataCreate, editingDriver.id);
        setDrivers((prev) =>
          prev.map((d) =>
            d.id === editingDriver.id ? response.data.driver : d
          )
        );
      } else {
        response = await GetUser.DriverCreate(formDataCreate);

        setDrivers((prev) => [response.data.driver, ...prev]);
      }

      toast.success(
        `${isEditing ? "Driver updated" : "Driver added"} successfully!`
      );
      setEditingDriver(null);
      setShowModal(false);
    } catch (error) {
      console.error("Error saving driver:", error);
      toast.error("Failed to save driver. Please try again.");
    }
  };

  return (
    <div className="max-w-md mx-auto bg-white p-6 shadow-md rounded-xl">
      <form onSubmit={handleSubmit} className="space-y-3">
        {/* Driver core fields */}
        {[
          "name",
          "country",
          "phone_number",
          "email",
          "registration_number",
          "driving_license",
        ].map((field) => (
          <div key={field} className="form-group">
            <label htmlFor={field}>{field.replace("_", " ")}</label>
            <input
              id={field}
              name={field}
              value={formData[field]}
              onChange={handleChange}
              placeholder={field}
              className="form-control"
              required
            />
          </div>
        ))}

        {/* Vehicle selection */}
        <div className="form-group">
          <label htmlFor="vehicleId">Select Vehicle</label>
          <select
            id="vehicleId"
            name="vehicleId"
            value={formData.vehicleId}
            onChange={handleChange}
            className="form-control"
          >
            <option value="">-- Select Vehicle --</option>
            {vehicles.map((v) => (
              <option key={v.id} value={v.id}>
                {v.plate_no} ({v.model})
              </option>
            ))}
          </select>
        </div>

        {/* File upload */}
        <div className="form-group">
          <label htmlFor="documents">Driving Licence Documents</label>
          <input
            id="documents"
            type="file"
            onChange={(e) => setDrivingLicence(e.target.files[0])}
            className="form-control"
          />
        </div>
        <div className="form-group">
          <label htmlFor="documents">
            Nationa Id/Identification card Documents
          </label>
          <input
            id="documents"
            type="file"
            onChange={(e) => setNationalId(e.target.files[0])}
            className="form-control"
          />
        </div>
        <div className="form-group">
          <label htmlFor="documents">Upload Documents</label>
          <input
            id="documents"
            type="file"
            multiple
            onChange={handleFileChange}
            className="form-control"
          />
          <small className="text-muted">
            You can upload multiple files (Birth Certificate, Insurance, support
            document, etc.)
          </small>
        </div>

        {/* Submit */}
        <button type="submit" className="btn btn-primary w-full">
          {isEditing ? "Update Driver" : "Register Driver"}
        </button>
      </form>
    </div>
  );
};

export default AddEditDriver;
